import { isNil, isNotNil } from '@flowio/is';
import getStyle from './getStyle';
import getOwnerDocument from './getOwnerDocument';
import isHTMLElement from './isHTMLElement';
/**
 * Returns a reference to the object which is the closest (nearest in
 * the containment hierarchy) positioned containing element.
 */

export default function getOffsetParent(element) {
  var offsetParent = element.offsetParent;

  while (isNotNil(offsetParent) && getStyle(offsetParent, 'position') === 'static') {
    offsetParent = isHTMLElement(offsetParent) ? offsetParent.offsetParent : null;
  }

  if (isNil(offsetParent)) {
    offsetParent = getOwnerDocument(element).documentElement;
  }

  return offsetParent;
}
//# sourceMappingURL=getOffsetParent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getOffsetParent.js
// module id = 470
// module chunks = 0 1